import * as _4 from 'lodash4';

export class PreviewTermBox {
  private term: any;
}

angular.module('capability-ng-academic-planner').component('previewTermBox', {
  templateUrl:
    'capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_term_box/preview_term_box.html',
  bindings: {
    term: '<'
  },
  controller: PreviewTermBox
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_term_box/preview_term_box.ts